import { NgModule } from '@angular/core';
import { LayoutModule } from '../../layout/layout.module';
import { ComponentsModule } from '../../components/components.module';
import { PlanejamentoComponent } from './planejamento/planejamento.component';
import { DiarioObraComponent } from './diario-obra/diario-obra.component';
import { PlanejamentoRoutingModule } from './planejamento-routing.module';

@NgModule({
  declarations: [PlanejamentoComponent, DiarioObraComponent],
  imports: [PlanejamentoRoutingModule, ComponentsModule, LayoutModule],
  exports: [],
})
export class PlanejamentoModule {}
